module.exports = __webpack_public_path__ + "img/offeo-1.8a3a9cd7.jpg";